import { PaymentProcessorEnum } from '@systemeio/ui'
import {
  CsvDataInterface,
  ExportPdfDataInterface,
  ExportXmlDataInterface,
} from 'modules/payment/transactions/types/export-interface'
import { FetcherType, RequestMethodsEnum } from 'shared/hooks/use-fetch/types'
import httpClient from 'shared/utils/http-client'

export const TRANSACTIONS_API = '/api/dashboard/customer/payment/transactions'

export const refundTransaction = (id: number) =>
  httpClient.post(`/api/dashboard/customer/payment/payment/refund/${id}`)

export const refundTransactionNew = (
  id: number,
  amount: number | null,
  paymentProcessor: PaymentProcessorEnum,
) =>
  httpClient.post(`/api/payment/integration/${paymentProcessor}/payments/${id}/refund`, { amount })

export const exportTransactionPdf = (exportPdfData: ExportPdfDataInterface) =>
  httpClient.post(`${TRANSACTIONS_API}/export-pdf`, exportPdfData)

export const exportTransactionXml = (exportXmlData: ExportXmlDataInterface) =>
  httpClient.post(`${TRANSACTIONS_API}/export-xml`, exportXmlData)

export const exportTransactionCsv = (
  csvData: CsvDataInterface,
  fetcher: FetcherType<RequestMethodsEnum.post>,
) => {
  return fetcher(`${TRANSACTIONS_API}/export-csv`, csvData)
}

export const sendCreditNote = (id: number) =>
  httpClient.post(`/api/dashboard/customer/payment/credit-note/send-to-customer/${id}`)

export const sendSalesInvoice = (id: number) =>
  httpClient.post(`/api/dashboard/customer/payment/sales-invoice/send-to-customer/${id}`)
